import apiClient from './apiClient';

export interface AcceptanceRun {
  runId: string;
  formId: string;
  chainId: string;
  contractHash: string;
  documentKey?: string;
  status: 'in_progress' | 'pass' | 'fail' | 'cancelled';
  resultNote: string;
  evidenceSummary: unknown;
  startedBy: string;
  startedAt: string;
  completedBy?: string;
  completedAt?: string;
}

export const acceptanceRunApi = {
  async start(payload: { formId: string; chainId: string; contractHash: string; documentKey?: string }) {
    return (await apiClient.post<AcceptanceRun>('/api/acceptance/runs', payload)).data;
  },
  async complete(runId: string, status: 'pass' | 'fail' | 'cancelled', resultNote: string, evidenceSummary: unknown) {
    return (await apiClient.put<AcceptanceRun>(
      `/api/acceptance/runs/${encodeURIComponent(runId)}/complete`,
      { status, resultNote, evidenceSummary },
    )).data;
  },
  async list(formId: string) {
    return (await apiClient.get<{ data: AcceptanceRun[] }>('/api/acceptance/runs', {
      params: { formId },
    })).data.data;
  },
};
